import React from "react";
import { COLORS, Typo } from "../../../../../layout/theme";
import {
	AntdTable,
	BigChartContainer,
	Container,
	Dashboard1Container,
	FilterContainer,
	Section,
	TextContainer,
} from "./styles";
import { Button, DatePicker, Select } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { numberWithDotAndCommas } from "../../../../../../utils/numberWithDotAndComas";
import CustomAntdTooltip from "../../../../../common/custom-antd-tooltip/CustomAntdTooltip";
import DebounceSelectSeller from "../../../../../common/debounce-select-seller/DebounceSelectSeller";
import { CONSTANTS } from "../../../../../../utils/constants";
import { BiCheck, BiTrash } from "react-icons/bi";

export default function ProductDashboard({
	distributors,
	selectDistributor,
	handleDateChange,
	deleteFilters,
	isLoading,
	selectedDistributor,
	productsTable,
	rangeDate,
	selectedChain,
	selectChain,
	chains,
	selectedBrand,
	selectBrand,
	brands,
	selectedCategory,
	selectCategory,
	categories,
	handleDownloadProductsTable,
	sellers,
	selectSeller,
	selectedSeller,
	userdata,
	productsPeriod,
	selectProductsPeriod,
	handleApplyFilters,
}) {
	const columns = [
		{
			title: () => <div style={{ color: COLORS.DarkGrey }}>Nombre</div>,
			width: 230,
			dataIndex: "productName",
			render: (value, record) => (
				<TextContainer>
					<Typo level={6}>{value}</Typo>
				</TextContainer>
			),
		},
		{
			title: () => <div style={{ color: COLORS.DarkGrey }}>Presentación</div>,
			width: 150,
			dataIndex: "productPresentation",
			render: (value, record) => (
				<TextContainer>
					<Typo level={6} type="secondary">
						{value}
					</Typo>
				</TextContainer>
			),
		},
		{
			title: () => <div style={{ color: COLORS.DarkGrey }}>Marca</div>,
			width: 130,
			dataIndex: "brandName",
			render: (value, record) => (
				<TextContainer>
					<Typo level={6} type="secondary">
						{value}
					</Typo>
				</TextContainer>
			),
		},
		{
			title: () => <div style={{ color: COLORS.DarkGrey }}>Ean</div>,
			width: 140,
			dataIndex: "productEan",
			render: (value, record) => (
				<Typo level={6} type="secondary">
					{value}
				</Typo>
			),
		},
		{
			title: () => <div style={{ color: COLORS.DarkGrey }}>Categorías</div>,
			width: 200,
			dataIndex: "categoryNameList",
			render: (value, record) => (
				<TextContainer>
					<Typo level={6} type="secondary">
						{value}
					</Typo>
				</TextContainer>
			),
		},
		{
			title: () => <div style={{ color: COLORS.DarkGrey }}>Total Un.</div>,
			dataIndex: "totalUnits",
			width: 110,
			render: (value, record) => (
				<TextContainer>
					<Typo type="primary" level={5}>
						{value}
					</Typo>
				</TextContainer>
			),
		},
		{
			title: () => (
				<Section>
					<div style={{ color: COLORS.DarkGrey, width: "100%" }}>Total $</div>
					<CustomAntdTooltip
						placement="top"
						width="105px"
						tooltipContent={[
							{
								body: "Exportar datos",
							},
						]}
					>
						<DownloadOutlined
							onClick={handleDownloadProductsTable}
							style={{
								color: COLORS.Warning,
								cursor: "pointer",
								width: "100%",
							}}
						/>
					</CustomAntdTooltip>
				</Section>
			),
			dataIndex: "totalPrice",
			width: 180,
			render: (value, record) => (
				<TextContainer>
					<Typo type="terciary" level={5}>
						$ {numberWithDotAndCommas(value)}
					</Typo>
				</TextContainer>
			),
		},
	];

	return (
		<Dashboard1Container>
			<FilterContainer>
				<Container
					style={{
						flexDirection: "row",
						alignItems: "end",
						justifyContent: "center",
						width: "150px",
					}}
				>
					<CustomAntdTooltip
						placement="top"
						width="110px"
						tooltipContent={[
							{
								title: `Aplicar filtros`,
							},
						]}
					>
						<Button
							type="primary"
							onClick={handleApplyFilters}
							icon={<BiCheck />}
							style={{
								borderRadius: 20,
								backgroundColor: COLORS.Success,
								borderColor: COLORS.Success,
							}}
						/>
					</CustomAntdTooltip>
					<CustomAntdTooltip
						placement="top"
						width="100px"
						tooltipContent={[
							{
								title: `Borrar filtros`,
							},
						]}
					>
						<Button
							type="danger"
							onClick={deleteFilters}
							icon={<BiTrash />}
							style={{ borderRadius: 20 }}
						/>
					</CustomAntdTooltip>
				</Container>
				<Container>
					<Typo type="primary" level={6}>
						Fecha
					</Typo>
					{rangeDate ? (
						<DatePicker.RangePicker
							format="DD/MM/YYYY"
							value={rangeDate}
							onChange={(e) => handleDateChange(e)}
							disabled={productsPeriod === CONSTANTS.PERIOD_CURRENT}
						/>
					) : (
						<DatePicker.RangePicker
							format="DD/MM/YYYY"
							onChange={(e) => handleDateChange(e)}
							placeholder={["Desde", "Hasta"]}
							disabled={productsPeriod === CONSTANTS.PERIOD_CURRENT}
						/>
					)}
				</Container>
				<Container>
					<Typo type="primary" level={6}>
						Período
					</Typo>
					<Select
						showSearch
						//allowClear
						placeholder="Período"
						optionFilterProp="children"
						value={productsPeriod}
						onChange={(e) => selectProductsPeriod(e)}
						filterOption={(input, option) =>
							(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
						}
						options={CONSTANTS.MOBILE_DASHBOARD_PERIODS}
						style={{ width: 130 }}
					/>
				</Container>
				<Container>
					<Typo type="primary" level={6}>
						Droguería
					</Typo>
					<Select
						showSearch
						placeholder="Droguería"
						optionFilterProp="children"
						value={selectedDistributor}
						onChange={(e, o) => selectDistributor(e, o)}
						filterOption={(input, option) =>
							(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
						}
						options={distributors}
						style={{ width: 140 }}
					/>
				</Container>
				<Container>
					<Typo type="primary" level={6}>
						Cadena
					</Typo>
					<Select
						showSearch
						placeholder="Cadena"
						optionFilterProp="children"
						value={selectedChain}
						onChange={(e, o) => selectChain(e, o)}
						filterOption={(input, option) =>
							(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
						}
						options={chains}
						style={{ width: 120 }}
					/>
				</Container>
				<Container>
					<Typo type="primary" level={6}>
						Categoria
					</Typo>
					<Select
						showSearch
						placeholder="Categoria"
						optionFilterProp="children"
						value={selectedCategory}
						onChange={(e, o) => selectCategory(e, o)}
						filterOption={(input, option) =>
							(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
						}
						options={categories}
						style={{ width: 160 }}
					/>
				</Container>
				<Container>
					<Typo type="primary" level={6}>
						Marca
					</Typo>
					<Select
						showSearch
						placeholder="Marca"
						optionFilterProp="children"
						value={selectedBrand}
						onChange={(e, o) => selectBrand(e, o)}
						filterOption={(input, option) =>
							(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
						}
						options={brands}
						style={{ width: 130 }}
					/>
				</Container>
				{!(!userdata.p_shop && userdata.p_mobile) && (
					<Container>
						<Typo type="primary" level={6}>
							Vendedor
						</Typo>
						<DebounceSelectSeller
							fetchCallback={sellers}
							placeholder="Vendedor"
							onValuesChange={selectSeller}
							initialValues={selectedSeller}
						/>
					</Container>
				)}
			</FilterContainer>
			<BigChartContainer>
				<AntdTable
					dataSource={productsTable}
					loading={isLoading}
					columns={columns}
					pagination={false}
					scroll={{ y: "1020px" }}
				/>
			</BigChartContainer>
		</Dashboard1Container>
	);
}
